<template>
  <tbody class="chart-body">
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  name: 'chart-body'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.chart-body {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ChartBody.vue